import { Button, Divider, Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';
import BtnSave from './BtnSave';
import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import TextBox from '../../Shared/TextBox';
import { EXAMLE, INIT } from './init';
import { checkValidForm } from './Step1';
import { useEffect } from 'react';
import { POLICY_NAME } from '../../POLICY';

const Step4 = (props) => {
    const { t } = useTranslation(['translation', POLICY_NAME.CCTV_POLICY]);

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep4(true);
            })
            .catch(() => props.setStep4(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.cctvReasonCollectedData) {
            onValuesChange(null, props.previewData?.cctvReasonCollectedData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'cctvPurposeTitleTh',
            'cctvPurposeTitleEn',
            'cctvPurposeContentTh',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep4(check);
    };

    const cctvCompanyNameTh =
        props.cctvPolicy?.cctvCompanyNameTh || '[company_name]';
    const cctvCompanyNameEn =
        props.cctvPolicy?.cctvCompanyNameEn || '[company_name]';

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('Reason for collected data', {
                    ns: POLICY_NAME.CCTV_POLICY,
                })}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="cctvReasonCollectedData"
                layout="vertical"
                form={props?.form}
                initialValues={INIT.cctvReasonCollectedData}
            >
                <div>
                    <div className="text-purple-PHX font-semibold text-xl">
                        {t(
                            'Purpose of collect, use or disclose Personal Data',
                            {
                                ns: POLICY_NAME.CCTV_POLICY,
                            }
                        )}
                    </div>
                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'TH',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvPurposeTitleTh"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvPurposeContentTh.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameTh
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvPurposeContentTh"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'TH' })}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'TH' })}
                        />
                    </Form.Item>

                    <Form.Item
                        label={
                            <span className="text-sm font-semibold">
                                {t(
                                    'Title of the topic displayed in the document',
                                    {
                                        ns: POLICY_NAME.CCTV_POLICY,
                                        lang: 'EN',
                                    }
                                )}
                            </span>
                        }
                        rules={[
                            {
                                required: true,
                                message: t('errorText.requiredField'),
                            },
                        ]}
                        name="cctvPurposeTitleEn"
                    >
                        <Input size="large" maxLength={200} showCount />
                    </Form.Item>
                    <div className="text-sm font-semibold">
                        {t('Example Data')}
                    </div>
                    <TextBox
                        code={EXAMLE.cctvPurposeContentEn.replace(
                            /\{\{c\}\}/g,
                            cctvCompanyNameEn
                        )}
                    />
                    <Form.Item
                        className="mt-4"
                        name="cctvPurposeContentEn"
                        label={
                            <span className="text-sm font-semibold">
                                {t('Content', { lang: 'EN' })}
                            </span>
                        }
                    >
                        <Editor
                            size="large"
                            rows={4}
                            placeholder={t('Content', { lang: 'EN' })}
                        />
                    </Form.Item>
                    <Form.Item
                        hidden
                        name="cctvReasonCollectedDataId"
                    ></Form.Item>
                    <Form.Item hidden name="cctvPurposeIsDisplay"></Form.Item>
                </div>

                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave
                            loading={props.loadingSaveDraft}
                            saveDraft={props.saveDraft}
                        />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step4;
